import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  ContentLookup,
  SuccessResponse,
  X1Language,
  X2AgeCategory,
  X3Level,
  X3LevelUpdateModel
} from '../../../../domain';
import {
  Control,
  HttpPromiseState,
  newValueForSelection,
  SaveStateHolder,
  validators
} from '../../../../lib/helpers';

export class MoveLevelStore implements SaveStateHolder {
  language: Control<X1Language | null>;
  ageCategory: Control<X2AgeCategory | null>;


  @observable.ref
  readonly languageOptions: readonly X1Language[];

  @observable.ref
  ageCategoryOptions: readonly X2AgeCategory[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly level: X3Level,
              readonly lookup: ContentLookup) {
    makeObservable(this);
    this.language = new Control<X1Language | null>(
      'Language',
      level.AgeCategory!.Language,
      validators.required
    );

    this.language.addValueChangeListener((language) => {
      this.ageCategoryOptions = [];
      if (language !== null)
        this.ageCategoryOptions = language.AgeCategories!;
      const newValue = newValueForSelection(this.ageCategoryOptions, this.ageCategory.value);
      this.ageCategory.setValue(newValue);
    });

    this.ageCategory = new Control<X2AgeCategory | null>(
      'AgeCategory',
      level.AgeCategory,
      validators.required
    );

    this.languageOptions = lookup.Languages;
    this.ageCategoryOptions = level.AgeCategory!.Language!.AgeCategories!;

    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.language.markTouched();
    this.ageCategory.markTouched();
    if (this.ageCategory.invalid)
      return;

    const model: X3LevelUpdateModel = {
      AgeCategoryId: this.ageCategory.value!.Id,
      Name: this.level.Name
    };
    this.save = contentLoaders.x3level.update(this.level.Id, model);
  }
}
